import React from "react";

export default function StudentVisaConsultantForUK() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-10">

                {/* Main Heading */}
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Why Consult a UK Student Visa Expert?
                </h2>

                <p className="text-gray-800 text-base sm:text-lg leading-relaxed text-justify">
                    Studying in the UK requires careful planning and complete understanding of visa regulations. 
                    A professional UK Student Visa Consultant ensures that your application process is accurate, 
                    timely, and aligned with immigration guidelines.
                </p>

                {/* Services List */}
                <div className="space-y-4 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <ul className="list-disc list-inside space-y-3">
                        <li>
                            <strong>UCAS & Non-UCAS Application Support:</strong> From profile drafting to deadline management for top UK universities.
                        </li>
                        <li>
                            <strong>Language Test Guidance:</strong> IELTS, PTE, TOEFL, and Duolingo preparation with score-based university selection.
                        </li>
                        <li>
                            <strong>Healthcare & NHS Registration Support:</strong> Assistance with NHS registration, medical surcharge, and healthcare guidance.
                        </li>
                        <li>
                            <strong>Eligibility Assessment:</strong> Academic evaluation and certification verification for your chosen course.
                        </li>
                        <li>
                            <strong>Work Opportunities Guidance:</strong> On-campus, off-campus jobs and post-study work options like the Graduate Route.
                        </li>
                        <li>
                            <strong>Post-Visa Support:</strong> Help with accommodation, bank account setup, healthcare access, and settling in the UK.
                        </li>
                    </ul>
                </div>

                {/* Why Choose Section */}
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mt-6">
                    Why Choose Shivasya?
                </h2>

                <p className="text-gray-800 text-base sm:text-lg leading-relaxed text-justify">
                    Shivasya is a trusted UK Student Visa Consultant in Ahmedabad with a dedicated team 
                    committed to helping students achieve their study abroad goals smoothly and successfully.
                </p>

                <div className="space-y-4 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <ul className="list-disc list-inside space-y-3">
                        <li>Personalized visa strategies aligned with your career goals</li>
                        <li>Error-free documentation and accurate application submission</li>
                        <li>Higher visa approval chances with professional expertise</li>
                        <li>Complete end-to-end support before and after visa approval</li>
                    </ul>
                </div>
            </div>
        </section>
    );
}